
document.addEventListener("DOMContentLoaded", (event) => {
   if (theme.settings.ab034 !== "v0" || theme.settings.ab103 !== "v0") {
     if (
      document.body.classList.contains("template-product") ||
      document.querySelectorAll(".custom-ab34-template-taie-oreiller").length >
        0 ||
      document.querySelectorAll(".custom-ab34-template-pads").length > 0
    ) {
  
      let previousClass = document.body.className;
      setInterval(function () {
        let currentClass = document.body.className;
        if (currentClass !== previousClass) {
          previousClass = currentClass;
          onBodyClassChange(currentClass);
        }
      }, 500); // Check every 500 milliseconds. Adjust the interval as needed.
    }
   }
  

  function onBodyClassChange(newClass) {
    console.log("Body class changed:", newClass);
    updateAB034Content();
  }
});
const updateAB034Content = async () => {
  if (
    document.body.classList.toLocaleString().match("hw-abt-34") != null &&
    document.body.classList.toLocaleString().match("hw-abt-34").length > 0
  ) {
    if (
      document.querySelectorAll(".custom-ab34-template-taie-oreiller").length >
        0 ||
      document.querySelectorAll(".custom-ab34-template-pads").length > 0
    ) {
      updateTaieTemplateCollectionGrid();
      updatePadsTemplateCollectionGrid();
    }
      await updateAB034Slider();
  } else if (
    document.body.classList.toLocaleString().match("hw-abt-103") != null &&
    document.body.classList.toLocaleString().match("hw-abt-103").length > 0
  ) {
    if (
      document.querySelectorAll(".custom-ab34-template-taie-oreiller").length >
        0 ||
      document.querySelectorAll(".custom-ab34-template-pads").length > 0
    ) {
      updateTaieTemplateCollectionGrid();
      updatePadsTemplateCollectionGrid();
    }
      await updateAB034Slider();
  }
};



const initTestProductSlider = ($mainSlider,$thumbSlider) =>{
   initTestProductVideo($mainSlider);
  var thumbnailsVertical = $thumbSlider.data("position") === "beside" ? true : false;
  $mainSlider.slick({
    adaptiveHeight: thumbnailsVertical ? false : true,
    asNavFor: `#${$thumbSlider.attr("id")}`,
    infinite: false,
    arrows: false,
    dots: false,
    initialSlide: 0,
    slidesToShow:1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
            slidesToShow:  (($('.ab025b_v1').length > 0 || $("body.hw-abt-2-1").length > 0 ) ? 1.2 : 1)
        }
      }
    ]
  });
  $thumbSlider.slick({
    asNavFor: `#${$mainSlider.attr("id")}`,
    slidesToShow: thumbnailsVertical ? 3 : 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: thumbnailsVertical,
    verticalSwiping: thumbnailsVertical,
    focusOnSelect: true,
    infinite: false,
    customHeightMatching: thumbnailsVertical,
    customSlideAdvancement: true,
    initialSlide: 0,
  });
 
}
const initTestProductVideo = ($mainSlider) => {
   var $productVideos = $mainSlider.find('product__video');
  var videoTypes = [];

  $productVideos.each(function () {
    var type = $(this).data("video-type");

    if (videoTypes.indexOf(type) < 0) {
      videoTypes.push(type);
    }
  });
  if (videoTypes.indexOf("mp4") > -1) {
    loadTestMp4Videos($productVideos);
  }
}
const loadTestMp4Videos = ($videos) => {
  $videos.each(function () {
        var $el = $(this);
        if ($el.data("video-type") != "mp4") {
          return;
        }

        var id = $el.attr("id");
        var videoId = $el.data("video-id");
        console.log("video id" + videoId);
        videos[this.id] = {
          type: "mp4",
          divId: id,
          style: $el.data("video-style"),
        };
      });
}
const updateAB034Slider = async () => {
  if(document.querySelectorAll(".custom-ab-image-test").length <= 0){
    return;
  }
  if ((theme.settings.ab034 !== "v0" || theme.settings.ab103 !== "v0") && document.querySelectorAll(".custom-product-slider-data").length > 0) {
    if (theme.settings.productTemplate35 == "taie-oreiller") {
      document.querySelectorAll(".custom-product-slider-data").forEach((el) => {
          if(el.dataset.test == theme.settings.ab103){
             el.classList.remove("hide");
              const mainSliderElement = el.querySelector(".main-slider-wrapper");
              const thumbSliderElement = el.querySelector(".product__thumbs");
              if(el.querySelectorAll(".slick-initialized").length > 0){
                const mainSlider = $(mainSliderElement).slick('getSlick');
                const thumbSlider = $(thumbSliderElement).slick('getSlick');
                mainSlider.refresh();
                thumbSlider.refresh();
              }else{
                initTestProductSlider($(mainSliderElement),$(thumbSliderElement))
              }
          }else{
            if(theme.settings.ab034 == 'test'){
              if(document.body.classList.contains('hw-abt-103-1') && el.dataset.test == 'v1'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-2') && el.dataset.test == 'v2'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-3') && el.dataset.test == 'v3'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-4') && el.dataset.test == 'v4'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-5') && el.dataset.test == 'v5'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-6') && el.dataset.test == 'v6'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-7') && el.dataset.test == 'v7'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-8') && el.dataset.test == 'v8'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-103-9') && el.dataset.test == 'v9'){
                displaySliderAndRefresh(el);
              }else if(el.dataset.test == 'v0' && document.body.classList.toLocaleString().match("hw-abt-103") === null ){
                displaySliderAndRefresh(el);
              }else{
                 el.classList.add("hide");
              }
            }else{
              el.classList.add("hide");
            }
          }
      });
    } else if (theme.settings.productTemplate35 == "pads") {
      
      document.querySelectorAll(".custom-product-slider-data").forEach((el) => {
          console.log(el.dataset.test,theme.settings.ab034);
          if(el.dataset.test == theme.settings.ab034){
             displaySliderAndRefresh(el);
          }else{
            if(theme.settings.ab034 == 'test'){
              if(document.body.classList.contains('hw-abt-34-1') && el.dataset.test == 'v1'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-2') && el.dataset.test == 'v2'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-3') && el.dataset.test == 'v3'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-4') && el.dataset.test == 'v4'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-5') && el.dataset.test == 'v5'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-6') && el.dataset.test == 'v6'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-7') && el.dataset.test == 'v7'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-8') && el.dataset.test == 'v8'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-9') && el.dataset.test == 'v9'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-10') && el.dataset.test == 'v10'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.contains('hw-abt-34-11') && el.dataset.test == 'v11'){
                displaySliderAndRefresh(el);
              }else if(document.body.classList.toLocaleString().match("hw-abt-34") === null && el.dataset.test == 'v0'){
                displaySliderAndRefresh(el);
              }else{
                 el.classList.add("hide");
              }
            }else{
              el.classList.add("hide");
            }
            
          }
      });
    }
  }
};
const displaySliderAndRefresh = (el) => {
  el.classList.remove("hide");
  const mainSliderElement = el.querySelector(".main-slider-wrapper");
  const thumbSliderElement = el.querySelector(".product__thumbs");
  if(el.querySelectorAll(".slick-initialized").length > 0){
    /*const mainSlider = $(mainSliderElement).slick('getSlick');
    const thumbSlider = $(thumbSliderElement).slick('getSlick');
    mainSlider.refresh();
    thumbSlider.refresh();*/
  }else{
    initTestProductSlider($(mainSliderElement),$(thumbSliderElement))
  }
}
const updateTaieTemplateCollectionGrid = () => {
  if (
    document.querySelectorAll(".custom-ab34-template-taie-oreiller").length > 0
  ) {
    document
      .querySelectorAll(".custom-ab34-template-taie-oreiller")
      .forEach((el) => {
        if (el.querySelectorAll(".ab34-image-wrapper").length > 0) {
          el.querySelector(".default-image-wrapper-main").classList.add("hide");
          el.querySelector(".ab34-image-wrapper").classList.remove("hide");
        }
      });
  }
};
const updatePadsTemplateCollectionGrid = () => {
  if (document.querySelectorAll(".custom-ab34-template-pads").length > 0) {
    document.querySelectorAll(".custom-ab34-template-pads").forEach((el) => {
      if (el.querySelectorAll(".ab34-image-wrapper").length > 0) {
        console.log("eee", el);
        el.querySelector(".default-image-wrapper-main").classList.add("hide");
        el.querySelector(".ab34-image-wrapper").classList.remove("hide");
      }
    });
  }
};
document.addEventListener("DOMContentLoaded", (event) => {
  //initializeBodyObservationForAB034();
  if (
    (theme.settings.ab034 != "v0" && theme.settings.ab034 != "test") ||
    (theme.settings.ab103 != "v0" && theme.settings.ab103 != "test")
  ) {
    const ab034Interval = setInterval(async () => {
      if (
        document.querySelectorAll(".custom-ab34-template-taie-oreiller")
          .length > 0 ||
        document.querySelectorAll(".custom-ab34-template-pads").length > 0 ||
        (document.querySelectorAll(".product__main-photos .slick-initialized")
          .length > 0 &&
          document.querySelectorAll(".custom-product-slider-data").length > 1)
      ) {
        console.log("dddd");
        updateTaieTemplateCollectionGrid();
        updatePadsTemplateCollectionGrid();
        await updateAB034Slider();
        clearInterval(ab034Interval);
      }
    }, 500);
  }
});
